<template>
  <div class="data">
    <div class="horizontalLineData"></div>
    <sc-image class="data__icon" v-if="fields && fields.icon" :media="fields.icon" />
    <sc-richText class="data__label" v-if="fields && fields.label" :field="fields.label" />
  </div>
</template>

<script>
import { RichText, Image } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Healthcare-Graphic-Data',
  components: {
    ScRichText: RichText,
    ScImage: Image
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.data {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 2rem 0 0;
  padding-left: 5rem;
  margin-bottom: 2.4rem;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }

  @include tablet-up {
    flex-grow: 1;
    flex-basis: 0;
    flex-direction: column;
    text-align: center;
    margin: 0;
    padding-left: 0;
  }

  .horizontalLineData {
    position: absolute;
    top: 50%;
    left: 0;
    width: 0;
    height: 0.1rem;
    background-color: $divider;

    @include tablet-up {
      top: 4rem;
    }
  }

  &__icon {
    position: relative;
    top: 50%;
    opacity: 0;
    z-index: 1;
    background-color: $white;
    max-width: 6.3rem;
    margin-bottom: 1rem;
  }

  &__label {
    position: relative;
    @include font-styles('Arial', 1.6rem, 600, normal, 2rem, 0, $dark-blue);
    padding: 0 2rem;
    height: 100%;
    background-color: $white;
    z-index: 2;

    @include tablet-up {
      padding: 0;
    }
  }
}
</style>
